import React from 'react';
import Hero from './components/IQAC/distinctiveness/Hero';
import Main from './components/IQAC/distinctiveness/Main';

const IqacInstitutionalDistinctiveness = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacInstitutionalDistinctiveness;